export default function(instance){
    return{
        Update(){
            return instance.post('/Cache/Update');
        },
    }
}
